import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import videojs from "video.js";
import "videojs-contrib-quality-levels";
import $ from "jquery";
import "./videojs.css";
import "videojs-seek-buttons";
import "videojs-landscape-fullscreen";

// import ads from "videojs-contrib-ads";
import { Playstatus, Playtracking } from "../../Model/Player"; //Include Home
import { Appsflyer, branchIO } from "../../Helpers/Common"; //Include Home
import { isMobile } from "react-device-detect";
import BarLoader from "react-spinners/BarLoader";
import {
  BrowserRouter as Router,
  Routes,
  useParams,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
var SVGIcon = "";
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));
// videojs.registerPlugin("ads", ads);
/*-----------------LIVE TV-----------------------------*/

export function LiveTVplayer(data) {
  var Content_details = data.content?.contents[0];
  // Appsflyer("Live TV Watched", {
  //   "Promo Name": Content_details?.title,
  //   "Content ID": Content_details?.ID,
  // });
  // branchIO("Live TV Watched", {
  //   "Promo Name": Content_details?.title,
  //   "Content ID": Content_details?.ID,
  // });
  // var autoplays;
  const navigate = useNavigate();
  const videoRef = useRef();
  const [player, setPlayer] = useState(undefined);
  const [loader, setloader] = useState(true);
  // if (data.autoplay) {
  //   autoplays = true;
  // } else {
  //   autoplays = true;
  // }

  useEffect(() => {
    const videoJsOptions = {
      html5: {
        hls: {
          overrideNative: true,
          nativeControlsForTouch: true,
        },
        nativeVideoTracks: true,
      },
      hls: {
        withCredentials: false,
      },
      autoplay: true,
      preload: "auto",
      aspectRatio: "15:12",
      height: "100%",
      width: "100%",
      controls: true,
      fluid: true,
      responsive: true,
      textTrackSettings: false,
      nativeControlsForTouch: false,
      controlBar: {
        muteToggle: false,
        fullscreenToggle: true,
        volumePanel: {
          inline: false,
          volumeControl: {
            vertical: true,
          },
        },
      },
      liveui: true,
      fluid: true,
      fullscreen: [
        {
          enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
          alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
          iOS: true, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
        },
      ],
      poster: data.post,
      sources: [
        {
          src: data.data,
          // type: "application/x-mpegURL",
          // withCredentials: false,
        },
      ],
    };

    const p = videojs(videoRef.current, videoJsOptions);
    var Xr;
    if (typeof player !== "undefined") {
      Xr = Math.floor(Math.random() * 10000 + 1);
    }
    function myfun() {
      var CurrentTime = player.currentTime();
      playtracking(
        "LIVE TV",
        CurrentTime,
        Content_details?.ID,
        Content_details?.title
      );
      data.functionclose();
    }
    if (typeof player !== "undefined") {
      var myButton = p.controlBar.addChild("button", {});
      myButton.addClass("vjs-close-button");
      var myButtonDom = myButton.el();
      myButtonDom.innerHTML =
        '<img src="' + SVGIcon["search-close.svg"] + '" alt="Sign up" />';

      myButton.on(["tap", "click"], myfun);
    }

    p.on("timeupdate", function () {
      setloader(false);
    });

    p.on("pause", () => {
      var CurrentTime = p.currentTime();
      playstatus("LIVE TV", CurrentTime, Content_details?.ID, Xr);
    });

    p.on("play", () => {
      p.muted(false);
      if (typeof player !== "undefined") {
        var CurrentTime = player.currentTime();
        playstatus("LIVE TV", CurrentTime, Content_details?.ID, Xr);
      }
    });

    p.on("fullscreenchange", () => {
      if (typeof player !== "undefined") {
        if (p.isFullscreen() == false) {
          // data.functionclose();
        }
      }
    });

    setPlayer(p);
    return () => {
      if (player) player.dispose();
    };
  }, [player]);

  return (
    <>
      {/* {loader ? (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      ) : null} */}
      <div className="playtrailer">
        <video
          ref={videoRef}
          className={
            data.classname
              ? "vidPlayer video-js vjs-default-skin vjs-big-play-centered livetv hidelive"
              : "vidPlayer video-js vjs-default-skin vjs-big-play-centered livetv dddd"
          }
          style={{ height: "100vh", width: "100%", background: "#000" }}
          autoPlay
          muted
          playsInline={true}
        ></video>
      </div>
    </>
  );
}

/*----------------------MAIN PLAYER----------------------*/

export default function VideoPlayerHLS(data) {
  const videoRef = useRef();
  const [player, setPlayer] = useState(undefined);
  const [loader, setloader] = useState(undefined);

  useEffect(() => {
    const videoJsOptions = {
      html5: {
        hls: {
          overrideNative: true,
        },
      },
      hls: {
        withCredentials: true,
      },
      controlBar: {
        muteToggle: false,
        fullscreenToggle: false,
      },
      fullscreen: {
        enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
        alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
        iOS: true, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
      },
      autoplay: true,
      kind: "captions",
      preload: "auto",
      aspectRatio: "15:12",
      textTrackSettings: false,
      height: "100%",
      width: "100%",
      fluid: true,
      tracks: data.subtitles.subtitles,
      nativeControlsForTouch: false,
      responsive: true,
      qualityMenu: {
        useResolutionLabels: true,
      },
      controls: true,
      nativeTextTracks: false,
      textTracks: data.subtitles.subtitles,
      fullscreen: [
        {
          enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
          alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
          iOS: true, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
        },
      ],
      playbackRates: [0.5, 0.75, 1, 1.5, 2, 3],
      poster: data.post.large,
      sources: [
        {
          src: data.data,
          // type: "application/x-mpegURL",
          withCredentials: false,
        },
      ],
    };
    var Xr;
    if (typeof player !== "undefined") {
      Xr = Math.floor(Math.random() * 10000 + 1);
    }
    if (player) {
      player.hlsQualitySelector({ displayCurrentQuality: true, iOS: true });
      let qualityLevels = player.qualityLevels();
      qualityLevels.on("addqualitylevel", function (event) {
        let qualityLevel = event.qualityLevel;
        if (qualityLevel.height) {
          qualityLevel.enabled = true;
        } else {
          qualityLevels.removeQualityLevel(qualityLevel);
          qualityLevel.enabled = false;
        }
      });
    }

    const p = videojs(videoRef.current, videoJsOptions);
    let track = "";
    var tracks = data.subtitles.subtitles;
    // if(tracks.length >= checkwatchlater1){

    if (typeof player !== "undefined") {
      if (data.skip) {
        var value = data.skip;
        player.currentTime(value);
      }
      var myButton = p.controlBar.addChild("button", {});
      myButton.addClass("vjs-close-button");
      var myButtonDom = myButton.el();
      myButtonDom.innerHTML =
        '<img src="' + SVGIcon["search-close.svg"] + '" alt="Sign up" />';

      myButton.on(["tap", "click"], myfun);
      var backwordbtn = p.controlBar.addChild("button", {});
      backwordbtn.addClass("prevbtn");
      var backwordbtnDom1 = backwordbtn.el();
      backwordbtnDom1.innerHTML =
        '<span  class="player__button prevbtn"><img src="' +
        SVGIcon["Reload-Backward.svg"] +
        '" class="backward_player"><span class="hovereffetc"></span</span>';
      backwordbtn.on(["tap", "click"], backforward);

      var videotitle = p.controlBar.addChild("button", {});
      videotitle.addClass("video-title");
      var videotitleel = videotitle.el();
      videotitleel.innerHTML =
        '<div class="player-title" ><span>' +
        data.ContentDetails.title +
        "</span></div>";

      function backforward() {
        var value = eval(player.currentTime() - 10);
        if (Math.sign(value) != -1) player.currentTime(value);
        var CurrentTime = player.currentTime();
        playstatus(CurrentTime, data.ContentDetails.ID, Xr);
      }

      var forwordbtn = p.controlBar.addChild("button", {});
      forwordbtn.addClass("nextbtn");
      var forwordbtnDom1 = forwordbtn.el();
      forwordbtnDom1.innerHTML =
        '<span  class="player__button nextbtn"><img src="' +
        SVGIcon["Reload-Forward.svg"] +
        '" class="forward_player"><span class="hovereffetc"></span</span>';
      forwordbtn.on(["tap", "click"], seekforward);

      function seekforward() {
        var value = eval(player.currentTime() + 10);
        if (Math.sign(value) != -1) player.currentTime(value);
        var CurrentTime = player.currentTime();
        playstatus(CurrentTime, data.ContentDetails.ID, Xr);
      }
      //
      for (var i = 0; i < tracks.length; i++) {
        let track = tracks[i];
        var lang = tracks[i].label;
        var captionsrc = tracks[i].src;
        var captionkind = tracks[i].kind;
        p.addRemoteTextTrack(
          { kind: captionkind, label: lang, src: captionsrc },
          false
        );
        // find the captions track that's in english
        if (track.kind === "captions" && track.language === "en") {
          track.mode = "showing";
        }
      }

      var timeout;
      var srclang;

      p.textTracks().on("change", function action(event) {
        clearTimeout(timeout);

        var showing = this.tracks_.filter(function (track) {
          if (track.kind === "subtitles" && track.mode === "showing") {
            srclang = track.language;
            return true;
          }
        })[0];
        timeout = setTimeout(function () {
          player.trigger("subtitleChanged", showing);
        }, 10);
      });
    }

    function myfun() {
      var CurrentTime = player.currentTime();
      playtracking(
        "VIDEO",
        CurrentTime,
        data.ContentDetails?.ID,
        data.ContentDetails?.title
      );
      data.functionclose();
    }
    if (typeof player !== "undefined") {
      if (p.requestFullscreen) {
        p.requestFullscreen();
      } else if (p.mozRequestFullScreen) {
        p.mozRequestFullScreen();
      } else if (p.webkitRequestFullScreen) {
        p.webkitRequestFullScreen();
      } else if (p.msRequestFullscreen) {
        p.msRequestFullscreen();
      }

      /*if (p.webkitEnterFullScreen) {
        p.webkitEnterFullScreen();
      }*/
    }

    p.on("timeupdate", function () {
      if (data.subscribed === false) {
        var duraction = p.currentTime();
        if (data.ContentDetails.premium_tag) {
          if (duraction > 120) {
            p.pause();
            //data.showmodel.Showmodels();
            data.showmodel();
          }
        }
      }
    });

    p.on("play", () => {
      if (typeof player !== "undefined") {
        setloader(false);
        if (p.webkitEnterFullScreen) {
          p.webkitEnterFullScreen();
        }
        p.requestFullscreen();
      } else {
        setloader(true);
      }
    });
    p.on("fullscreenchange", () => {
      if (typeof player !== "undefined") {
        if (p.isFullscreen() == false) {
          var CurrentTime = player.currentTime();
          playstatus(CurrentTime, data.ContentDetails.ID, Xr);
          playtracking(
            "VIDEO",
            CurrentTime,
            data.ContentDetails.ID,
            data.ContentDetails.title
          );
          data.functionclose();
        }
      }
    });
    setPlayer(p);
    return () => {
      if (player) player.dispose();
    };
  }, [player]);

  const resolutionMap = {
    "2160p": "4K UHD",
    "1440p": "2K",
    "1080p": "FHD",
    "720p": "HD",
    "480p": "SD",
  };

  const qualitLevelLabel = document.querySelectorAll(".vjs-menu-item-text");
  qualitLevelLabel?.forEach((item) => {
    const resolutionText = item.innerText;
    if (resolutionMap.hasOwnProperty(resolutionText)) {
      item.textContent = resolutionMap[resolutionText];
    }
  });

  if (setloader == true) {
    return <div className="laoder" />;
  } else {
    return (
      <aa>
        <video
          ref={videoRef}
          className="vidPlayer video-js vjs-default-skin vjs-big-play-centered"
          style={{ height: "100%", width: "100%", background: "#000" }}
        ></video>
      </aa>
    );
  }
}

export function Bannerplayer(data) {
  const videoRef = useRef();
  const [player, setPlayer] = useState(undefined);
  const [loader, setloader] = useState(true);
  const [bannerImg, setBannerImg] = useState("");
  var subtitleCopyArr = [];
  var subtitles = [];
  const navigate = useNavigate();
  useEffect(() => {
    getData();
  }, [player]);
  var Xr;
  if (typeof player !== "undefined") {
    Xr = Math.floor(Math.random() * 10000 + 1);
  }
  const getData = () => {
    if (data.subtitles) {
      if (data.subtitles.length > 0) {
        for (var i in data.subtitles) {
          var tempObj = {};
          var tempObj2 = {};
          tempObj["srclang"] = data.subtitles[i]["lang"];
          tempObj["label"] = data.subtitles[i]["lang"];
          tempObj["src"] = data.subtitles[i]["file"];
          subtitleCopyArr.push(tempObj);
          tempObj2["srclang"] = "";
          tempObj2["label"] = "Off";
          tempObj2["src"] = "";
        }
        subtitles.push(tempObj2, ...subtitleCopyArr);
      }
    }
    var posterimg;
    if (data?.content_details?.banner_image?.large) {
      posterimg = data?.content_details?.banner_image?.large;
    } else if (data?.content_details?.banner_image?.medium) {
      posterimg = data?.content_details?.banner_image?.medium;
    }
    setBannerImg(posterimg);
    var videoJsOptions = {
      html5: {
        hls: {
          overrideNative: true,
          nativeControlsForTouch: true,
        },
        nativeTextTracks: false,
      },
      hls: {
        withCredentials: false,
      },
      controlBar: {
        muteToggle: false,
        fullscreenToggle: true,
        volumePanel: {
          inline: false,
          volumeControl: {
            vertical: true,
          },
        },
      },
      fullscreen: {
        enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
        alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
        iOS: false, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
      },
      autoplay: true,
      kind: "captions",
      preload: "auto",
      aspectRatio: "15:12",
      textTrackSettings: false,
      height: "100%",
      width: "100%",
      fluid: true,
      tracks: subtitles,
      nativeControlsForTouch: false,
      responsive: true,
      qualityMenu: {
        useResolutionLabels: true,
      },
      controls: true,
      fullscreen: [
        {
          enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
          alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
          iOS: true, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
        },
      ],
      playbackRates: [0.5, 0.75, 1, 1.5, 2, 3],
      poster: data?.content_details?.large,
      sources: [
        {
          src: data.data,
          // type: "application/x-mpegURL",
        },
      ],
    };

    const p = videojs(videoRef.current, videoJsOptions);

    if (data.content_details?.content_type == "SHOW") {
      data.content_details.content_type = "EPISODE";
    }

    let track = "";
    var tracks = subtitles;
    //Continue Watching
    if (typeof player !== "undefined") {
      if (data.content_details?.content_type == "EPISODE") {
        var value = eval(data.contentdata.user_duration);
        if (Math.sign(value) != -1) {
          p.currentTime(value);
        }
      } else {
        var value = eval(data.content_details?.user_duration);
        if (Math.sign(value) != -1) {
          p.currentTime(value);
        }
      }
    }

    if (isMobile) {
      p.landscapeFullscreen({
        fullscreen: {
          enterOnRotate: true,
          alwaysInLandscapeMode: true,
          iOS: false,
        },
      });
    } else {
      p.landscapeFullscreen({
        fullscreen: {
          enterOnRotate: true,
          alwaysInLandscapeMode: true,
          iOS: false,
        },
      });
    }
    function seekforsec() { }
    if (typeof player !== "undefined") {
      p.muted(false);
      player.hlsQualitySelector({ displayCurrentQuality: true, iOS: true });
      let qualityLevels = player.qualityLevels();
      qualityLevels.on("addqualitylevel", function (event) {
        let qualityLevel = event.qualityLevel;
        if (qualityLevel.height) {
          qualityLevel.enabled = true;
        } else {
          qualityLevels.removeQualityLevel(qualityLevel);
          qualityLevel.enabled = false;
        }
      });

      var myButton = p.controlBar.addChild("button", {});
      myButton.addClass("vjs-close-button");
      var myButtonDom = myButton.el();

      myButtonDom.innerHTML =
        '<img src="' + SVGIcon["search-close.svg"] + '" alt="Sign up" />';
      myButton.on(["tap", "click"], myfun);

      function myfun() {
        var CurrentTime = player.currentTime();
        //playstatus(data.content_details.content_type,CurrentTime, data.content_id,Xr);
        playtracking(
          data.content_details.content_type,
          CurrentTime,
          data.content_id,
          data.contentdata.title
        );
        data.functionclose();
      }

      var backwordbtn = p.controlBar.addChild("button", {});
      backwordbtn.addClass("prevbtn");
      var backwordbtnDom1 = backwordbtn.el();

      backwordbtnDom1.innerHTML =
        '<span  class="player__button prevbtn show-backward"><img src="' +
        SVGIcon["Reload-Backward.svg"] +
        '" class="backward_player"><span class="hovereffetc"></span</span>';

      backwordbtn.on(["tap", "click", "touchstart"], backforward);
      var videotitle = p.controlBar.addChild("button", {});
      videotitle.addClass("video-title");
      let titleImage = data?.contentdata?.title_image_newui?.original
        ? data?.contentdata?.title_image_newui?.original
        : data?.content_details?.title_image_newui?.original;
      var videotitleel = videotitle.el();
      videotitleel.innerHTML =
        '<div class="player-title" ><span><img src="' +
        titleImage +
        '" class="play-content-title" /></span></div>';
      var videoContentDescri = p.controlBar.addChild("button", {});
      videoContentDescri.addClass("video-descriptor");
      var videoContentDescriel = videoContentDescri.el();

      videoContentDescriel.innerHTML =
        '<div class="age_descriptor" ><span> Rated ' +
        data.content_details?.age_restriction +
        " | " +
        data.content_details?.content_category +
        "</span><span> " +
        data.content_details?.content_descriptors.join(" ") +
        "</span></div>";

      function backforward() {
        playstatus(
          data.content_details.content_type,
          player.currentTime(),
          data.content_id,
          Xr
        );
        var value = eval(player.currentTime() - 10);
        if (Math.sign(value) != -1) player.currentTime(value);

        if (isMobile) {
          backwordbtn.addClass("prevbtnColor");

          var timer1 = setTimeout(() => {
            backwordbtn.removeClass("prevbtnColor");
          }, 500);
          return () => {
            clearTimeout(timer1);
          };
        }
      }

      var forwordbtn = p.controlBar.addChild("button", {});
      forwordbtn.addClass("nextbtn");
      var forwordbtnDom1 = forwordbtn.el();
      forwordbtnDom1.innerHTML =
        '<span  class="player__button nextbtn"><img src="' +
        SVGIcon["Reload-Forward.svg"] +
        '" class="forward_player"><span class="hovereffetc"></span</span>';
      forwordbtn.on(["tap", "click", "touchstart"], seekforward);
      function seekforward() {
        playstatus(
          data.content_details.content_type,
          player.currentTime(),
          data.content_id,
          Xr
        );
        var value = eval(player.currentTime() + 10);
        if (Math.sign(value) != -1) player.currentTime(value);

        if (isMobile) {
          forwordbtn.addClass("nextbtnColor");

          var timer2 = setTimeout(() => {
            forwordbtn.removeClass("nextbtnColor");
          }, 500);
          return () => {
            clearTimeout(timer2);
          };
        }
      }
    }

    p.on("timeupdate", function () {
      var showMessage = false;
      var message = ""
      let smokingDiv = document.querySelector(".video-message");
      let smokingPara = document.querySelector(".message-content");
      if (data.message) {
        let seconds = parseInt(p.currentTime());
        let currentTime = seconds * 1000;
        for (let i = 0; i < data.message.length; i++) {
          let startTimeComponents = data.message[i].start_time.split(":");
          let endTimeComponents = data.message[i].end_time.split(":");
          if (
            startTimeComponents.length == 3 &&
            endTimeComponents.length == 3
          ) {
            let hours = parseInt(startTimeComponents[0]);
            let minutes = parseInt(startTimeComponents[1]);
            let seconds = parseInt(startTimeComponents[2]);
            let totalMillis = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
            let endHours = parseInt(endTimeComponents[0]);
            let endMinutes = parseInt(endTimeComponents[1]);
            let endSeconds = parseInt(endTimeComponents[2]);
            let endHoursInMillis = endHours * 60 * 60 * 1000;
            let endMinutesInMillis = endMinutes * 60 * 1000;

            let totalEndMillis =
              (endHours * 60 * 60 + endMinutes * 60 + endSeconds) * 1000;

            if (currentTime >= totalMillis && currentTime <= totalEndMillis) {
              if (data.message[i].text != null) {
                showMessage = true;
                message = data.message[i].text;
              }
            }
          } else if (
            startTimeComponents.length == 2 &&
            endTimeComponents.length == 2
          ) {
            let hours = 0;
            let minutes = parseInt(startTimeComponents[0]);
            let seconds = parseInt(startTimeComponents[1]);
            let totalMillis = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
            let endHours = 0;
            let endMinutes = parseInt(endTimeComponents[0]);
            let endSeconds = parseInt(endTimeComponents[1]);
            let endHoursInMillis = endHours * 60 * 60 * 1000;
            let endMinutesInMillis = endMinutes * 60 * 1000;
            let totalEndMillis =
              (endHours * 60 * 60 + endMinutes * 60 + endSeconds) * 1000;
            if (currentTime >= totalMillis && currentTime <= totalEndMillis) {
              if (data.message[i].text != null) {
                showMessage = true;
                message = data.message[i].text;
              }
            }
          }
          if (showMessage == true) {
            if (message === "") {
              smokingPara.innerText = "";
            }
            smokingPara.innerText = message;
            smokingDiv.style.visibility = "visible"

          } else {
            smokingDiv.style.visibility = "hidden"
          }
        }
      }
      setloader(false);
    });

    function myfun() {
      data.functionclose();
    }
    if (typeof player !== "undefined") {
      if (isMobile) {
        //
        window.scrollBy(0, 80);
        document.body.scroll = "no";
      }
    }
    p.on("play", () => {
      //
      if (typeof player !== "undefined") {
        //p.requestFullscreen();
        //p.muted(false);
        setloader(false);
      }
    });

    p.on("pause", () => {
      playstatus(
        data.content_details.content_type,
        p.currentTime(),
        data.content_id,
        Xr
      );
    });

    p.on("fullscreenchange", () => {
      if (typeof player !== "undefined") {
      }
    });

    setPlayer(p);
    return () => {
      if (player) player.dispose();
    };
  };

  function closebtn() {
    window.history.go(-1);
  }

  const resolutionMap = {
    "2160p": "4K UHD",
    "1440p": "2K",
    "1080p": "FHD",
    "720p": "HD",
    "480p": "SD",
  };

  const qualitLevelLabel = document.querySelectorAll(".vjs-menu-item-text");
  qualitLevelLabel?.forEach((item) => {
    const resolutionText = item.innerText;
    if (resolutionMap.hasOwnProperty(resolutionText)) {
      item.textContent = resolutionMap[resolutionText];
    }
  });

  return (
    <div className="playtrailer">
      <video
        ref={videoRef}
        className="vidPlayer video-js vjs-default-skin vjs-big-play-centered"
        style={{ height: "100vh", width: "100%", background: "#000" }}
        autoPlay
        muted
        controls
        playsInline={true}
      ></video>
      <div className="video-message">
        <p className="message-content"></p>
      </div>
    </div>
  );
}

export function VideoPlayerDocubytes(data) {
  const videoRef = useRef();
  const [player, setPlayer] = useState(false);

  useEffect(() => {
    const videoJsOptions = {
      autoplay: true,
      kind: "captions",
      preload: "auto",
      height: "auto",
      width: "100%",
      controls: false,
      poster: "",
      sources: [
        {
          src: data.data,
          // type: "application/x-mpegURL",
          withCredentials: false,
        },
      ],
    };
    if (player) {
      player.hlsQualitySelector({ displayCurrentQuality: true });
    }
    const p = videojs(videoRef.current, videoJsOptions);
    setPlayer(p);
    return () => {
      if (player) player.dispose();
    };
  }, [player]);

  return (
    <video
      ref={videoRef}
      poster={data.poster}
      className="vidPlayer video-js vjs-default-skin vjs-big-play-centered"
    /* style={{height: "auto",width:"100%"}}*/
    ></video>
  );
}

/*-------------Watch Trailer -------------*/

export function Watchtrailer(data) {
  // Appsflyer("Promo Watched", {
  //   "Promo Name": data.Contentdata.title,
  //   "Content ID": data.content_id,
  // });
  // branchIO("Promo Watched", {
  //   "Promo Name": data.Contentdata.title,
  //   "Content ID": data.content_id,
  // });
  // const videoRef = useRef();
  // const [player, setPlayer] = useState(undefined);

  // useEffect(() => {
  //   trailerData()
  // }, [player]);

  // const trailerData = () =>{
  //   var videoJsOptions = {
  //     html5: {
  //       hls: {
  //         overrideNative: true,
  //         nativeControlsForTouch: true,
  //       },
  //       nativeTextTracks: false,
  //     },
  //     hls: {
  //       withCredentials: true,
  //     },
  //     fullscreen: {
  //       enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
  //       alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
  //       iOS: true, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
  //     },
  //     autoplay: true,
  //     kind: "captions",
  //     preload: "auto",
  //     aspectRatio: "15:12",
  //     width: "100%",
  //     height: "100%",
  //     fluid: true,
  //     textTrackSettings: false,
  //     nativeControlsForTouch: false,
  //     responsive: true,
  //     qualityMenu: {
  //       useResolutionLabels: true,
  //     },
  //     controlBar: {
  //       muteToggle: false,
  //       fullscreenToggle: true,
  //       volumePanel: {
  //         inline: false,
  //         volumeControl: {
  //           vertical: true,
  //         },
  //       },
  //     },
  //     controls: true,
  //     playbackRates: [0.5, 0.75, 1, 1.5, 2, 3],
  //     poster: data.Contentdata.banner_image?.medium,
  //     disablePictureInPicture: true,
  //     fullscreen: [
  //       {
  //         enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
  //         alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
  //         iOS: true, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
  //       },
  //     ],
  //     sources: [
  //       {
  //         src: data.Contentdata.promo_url,
  //         // type: "application/x-mpegURL",
  //         // withCredentials: false,
  //       },
  //     ],
  //   };

  //   const p = videojs(videoRef.current, videoJsOptions);
  //   var Xr;
  //   if (typeof player !== "undefined") {
  //     Xr = Math.floor(Math.random() * 10000 + 1);
  //   }
  //   if (typeof player !== "undefined") {
  //     p.muted(false);
  //     // player.landscapeFullscreen({
  //     //   fullscreen: {
  //     //     enterOnRotate: true,
  //     //     alwaysInLandscapeMode: true,
  //     //     iOS: false,
  //     //   },
  //     // });
  //     player.hlsQualitySelector({ displayCurrentQuality: true, iOS: true });
  //     let qualityLevels = player.qualityLevels();
  //     qualityLevels.on("addqualitylevel", function (event) {
  //       let qualityLevel = event.qualityLevel;
  //       if (qualityLevel.height) {
  //         qualityLevel.enabled = true;
  //       } else {
  //         qualityLevels.removeQualityLevel(qualityLevel);
  //         qualityLevel.enabled = false;
  //       }
  //     });
  //     // p.controlBar.options_.fullscreenToggle = true;
  //     /*p.controlBar({
  //             muteToggle: false,
  //             fullscreenToggle: true
  //           })*/
  //     var myButton = p.controlBar.addChild("button", {});
  //     myButton.addClass("vjs-close-button");
  //     var myButtonDom = myButton.el();
  //     myButtonDom.innerHTML =
  //       '<img src="' + SVGIcon["search-close.svg"] + '" alt="Sign up" />';
  //     myButton.on(["tap", "click"], myfun);
  //     function myfun() {
  //       var CurrentTime = player.currentTime();
  //       playtracking(
  //         "Promo",
  //         CurrentTime,
  //         data.content_id,
  //         data.Contentdata.title
  //       );
  //       data.functionclose();
  //     }

  //     var backwordbtn = p.controlBar.addChild("button", {});
  //     backwordbtn.addClass("prevbtn");
  //     var backwordbtnDom1 = backwordbtn.el();
  //     backwordbtnDom1.innerHTML =
  //       '<span  class="player__button prevbtn"><img src="' +
  //       SVGIcon["Reload-Backward.svg"] +
  //       '" class="backward_player"><span class="hovereffetc"></span</span>';
  //     backwordbtn.on(["tap", "click"], backforward);

  //     function backforward() {
  //       //Call playstatus
  //       var value = eval(player.currentTime() - 10);
  //       if (Math.sign(value) != -1) player.currentTime(value);
  //       var CurrentTime = player.currentTime();
  //       playstatus(CurrentTime, data.content_id, Xr);
  //     }

  //     var forwordbtn = p.controlBar.addChild("button", {});
  //     forwordbtn.addClass("nextbtn");
  //     var forwordbtnDom1 = forwordbtn.el();
  //     forwordbtnDom1.innerHTML =
  //       '<span  class="player__button nextbtn"><img src="' +
  //       SVGIcon["Reload-Forward.svg"] +
  //       '" class="forward_player"><span class="hovereffetc"></span</span>';
  //     forwordbtn.on(["tap", "click"], seekforward);

  //     function seekforward() {
  //       //Call playstatus
  //       var value = eval(player.currentTime() + 10);
  //       if (Math.sign(value) != -1) player.currentTime(value);
  //       var CurrentTime = player.currentTime();
  //       playstatus(CurrentTime, data.content_id, Xr);
  //     }
  //   }

  //   p.on("play", () => {
  //     //Call playstatus/

  //     if (typeof player !== "undefined") {
  //       var CurrentTime = player.currentTime();

  //       playstatus(CurrentTime, data.content_id, Xr);
  //       if (typeof player !== "undefined") {
  //         if (isMobile) {
  //           p.requestFullscreen();
  //         }
  //         /*if (p.requestFullscreen) {

  //           p.requestFullscreen();

  //         } else if (p.mozRequestFullScreen) {

  //           p.mozRequestFullScreen()
  //         } else if (p.webkitRequestFullScreen) {

  //           p.webkitRequestFullScreen()
  //         }
  //         else if (p.msRequestFullscreen) {

  //           p.msRequestFullscreen()
  //         } else {
  //           p.webkitEnterFullScreen();
  //         }*/
  //       }
  //     }
  //   });

  //   p.on("pause", () => {
  //     //Call playstatus
  //     /*if (typeof player !== "undefined") {
  //       p.requestFullscreen();
  //     }*/
  //   });

  //   p.on("fullscreenchange", () => {
  //     if (typeof player !== "undefined") {
  //       if (p.isFullscreen() == false) {
  //         //Call playstatus
  //         var CurrentTime = player.currentTime();
  //         playstatus(CurrentTime, data.content_id, Xr);
  //         playtracking(
  //           "Promo",
  //           CurrentTime,
  //           data,
  //           data.content_id,
  //           data.Contentdata.title
  //         );
  //         //data.functionclose();
  //       }
  //     }
  //   });
  //   setPlayer(p);
  //   if (p) {
  //     p.play();
  //   }
  //   return () => {
  //     if (player) {
  //       player.currentTime = 0;
  //       player.src = "";
  //     }
  //   };
  // }

  // const resolutionMap = {
  //   "2160p": "4K UHD",
  //   "1440p": "2K",
  //   "1080p": "FHD",
  //   "720p": "HD",
  //   "480p": "SD"
  // };

  // const qualitLevelLabelTrailer = document.querySelectorAll('.vjs-menu-item-text');

  // qualitLevelLabelTrailer?.forEach(item => {
  //   const resolutionText = item.innerText;
  //   if (resolutionMap.hasOwnProperty(resolutionText)) {
  //     item.textContent = resolutionMap[resolutionText];
  //   }
  // });

  // return (
  //   <div className="playtrailer">
  //     <video
  //       ref={videoRef}
  //       className="vidPlayer video-js vjs-default-skin vjs-big-play-centered"
  //       style={{ height: "100%", width: "100%", background: "#000" }}
  //       autoplay
  //       muted
  //       controls
  //       playsInline
  //     ></video>
  //   </div>
  // );

  const videoRef = useRef();
  const [player, setPlayer] = useState(undefined);
  const [loader, setloader] = useState(true);
  const [showmodel, setshowmodel] = useState(false);
  const [bannerImg, setBannerImg] = useState("");
  var subtitleCopyArr = [];
  var subtitles = [];
  const navigate = useNavigate();
  useEffect(() => {
    getData();
  }, [player]);
  var Xr;
  if (typeof player !== "undefined") {
    Xr = Math.floor(Math.random() * 10000 + 1);
  }
  const getData = () => {
    if (data.subtitles) {
      if (data.subtitles.length > 0) {
        for (var i in data.subtitles) {
          var tempObj = {};
          var tempObj2 = {};
          tempObj["srclang"] = data.subtitles[i]["lang"];
          tempObj["label"] = data.subtitles[i]["lang"];
          tempObj["src"] = data.subtitles[i]["file"];
          subtitleCopyArr.push(tempObj);
          tempObj2["srclang"] = "";
          tempObj2["label"] = "Off";
          tempObj2["src"] = "";
        }
        subtitles.push(tempObj2, ...subtitleCopyArr);
      }
    }
    var posterimg;
    if (data?.content_details?.banner_image?.large) {
      posterimg = data?.content_details?.banner_image?.large;
    } else if (data?.content_details?.banner_image?.medium) {
      posterimg = data?.content_details?.banner_image?.medium;
    }
    setBannerImg(posterimg);
    var videoJsOptions = {
      html5: {
        hls: {
          overrideNative: true,
          nativeControlsForTouch: true,
        },
        nativeTextTracks: false,
      },
      hls: {
        withCredentials: false,
      },
      controlBar: {
        muteToggle: false,
        fullscreenToggle: true,
        volumePanel: {
          inline: false,
          volumeControl: {
            vertical: true,
          },
        },
      },
      fullscreen: {
        enterOnRotate: true,
        alwaysInLandscapeMode: true,
        iOS: false,
      },
      autoplay: true,
      kind: "captions",
      preload: "auto",
      aspectRatio: "15:12",
      textTrackSettings: false,
      height: "100%",
      width: "100%",
      fluid: true,
      tracks: subtitles,
      nativeControlsForTouch: false,
      responsive: true,
      qualityMenu: {
        useResolutionLabels: true,
      },
      controls: true,
      fullscreen: [
        {
          enterOnRotate: true,
          alwaysInLandscapeMode: true,
          iOS: true,
        },
      ],
      playbackRates: [0.5, 0.75, 1, 1.5, 2, 3],
      poster: data?.content_details?.large,
      sources: [
        {
          src: data.data,
        },
      ],
    };

    const p = videojs(videoRef.current, videoJsOptions);

    if (data.content_details?.content_type == "SHOW") {
      data.content_details.content_type = "EPISODE";
    }

    let track = "";
    var tracks = subtitles;
    if (typeof player !== "undefined") {
      if (data.content_details?.content_type == "EPISODE") {
        var value = eval(data.contentdata.user_duration);
        if (Math.sign(value) != -1) {
          p.currentTime(value);
        }
      } else {
        var value = eval(data.content_details?.user_duration);
        if (Math.sign(value) != -1) {
          p.currentTime(value);
        }
      }
    }
    if (isMobile) {
      p.landscapeFullscreen({
        fullscreen: {
          enterOnRotate: true,
          alwaysInLandscapeMode: true,
          iOS: false,
        },
      });
    } else {
      p.landscapeFullscreen({
        fullscreen: {
          enterOnRotate: true,
          alwaysInLandscapeMode: true,
          iOS: false,
        },
      });
    }
    function seekforsec() { }
    // if (typeof player !== "undefined") {
    //   p.muted(false);
    //   player.hlsQualitySelector({ displayCurrentQuality: true, iOS: true });
    //   let qualityLevels = player.qualityLevels();
    //   qualityLevels.on("addqualitylevel", function (event) {
    //     let qualityLevel = event.qualityLevel;
    //     if (qualityLevel.height) {
    //       qualityLevel.enabled = true;
    //     } else {
    //       qualityLevels.removeQualityLevel(qualityLevel);
    //       qualityLevel.enabled = false;
    //     }
    //   });

    //   var myButton = p.controlBar.addChild("button", {});
    //   myButton.addClass("vjs-close-button");
    //   var myButtonDom = myButton.el();

    //   myButtonDom.innerHTML =
    //     '<img src="' + SVGIcon["search-close.svg"] + '" alt="Sign up" />';
    //   myButton.on(["tap", "click"], myfun);

    //   function myfun() {
    //     var CurrentTime = player.currentTime();
    //     playtracking(
    //       data.content_details.content_type,
    //       CurrentTime,
    //       data.content_id,
    //       data.contentdata.title
    //     );
    //     data.functionclose();
    //   }

    //   var backwordbtn = p.controlBar.addChild("button", {});
    //   backwordbtn.addClass("prevbtn");
    //   var backwordbtnDom1 = backwordbtn.el();

    //   backwordbtnDom1.innerHTML =
    //     '<span  class="player__button prevbtn show-backward"><img src="' +
    //     SVGIcon["Reload-Backward.svg"] +
    //     '" class="backward_player"><span class="hovereffetc"></span</span>';

    //   backwordbtn.on(["tap", "click"], backforward);
    //   var videotitle = p.controlBar.addChild("button", {});
    //   videotitle.addClass("video-title");
    //   let titleImage = data.contentdata?.title_image_newui.original ? data.contentdata?.title_image_newui.original : data.content_details?.title_image_newui.original
    //   var videotitleel = videotitle.el();
    //   videotitleel.innerHTML =
    //     '<div class="player-title" ><span><img src="' +
    //     titleImage +
    //     '" class="play-content-title" /></span></div>';
    //   var videoContentDescri = p.controlBar.addChild("button", {});
    //   videoContentDescri.addClass("video-descriptor");
    //   var videoContentDescriel = videoContentDescri.el();

    //   videoContentDescriel.innerHTML =
    //     '<div class="age_descriptor" ><span> Rated ' +
    //     data.content_details?.age_restriction +
    //     " | " +
    //     data.content_details?.content_category +
    //     "</span><span> " +
    //     data.content_details?.content_descriptors.join(" ") +
    //     "</span></div>";

    //   function backforward() {
    //     playstatus(
    //       data.content_details.content_type,
    //       player.currentTime(),
    //       data.content_id,
    //       Xr
    //     );
    //     var value = eval(player.currentTime() - 10);
    //     if (Math.sign(value) != -1) player.currentTime(value);
    //   }

    //   var forwordbtn = p.controlBar.addChild("button", {});
    //   forwordbtn.addClass("nextbtn");
    //   var forwordbtnDom1 = forwordbtn.el();
    //   forwordbtnDom1.innerHTML =
    //     '<span  class="player__button nextbtn"><img src="' +
    //     SVGIcon["Reload-Forward.svg"] +
    //     '" class="forward_player"><span class="hovereffetc"></span</span>';
    //   forwordbtn.on(["tap", "click"], seekforward);
    //   function seekforward() {
    //     playstatus(
    //       data.content_details.content_type,
    //       player.currentTime(),
    //       data.content_id,
    //       Xr
    //     );
    //     var value = eval(player.currentTime() + 10);
    //     if (Math.sign(value) != -1) player.currentTime(value);
    //   }
    // }
    if (typeof player !== "undefined") {
      p.muted(false);
      // player.landscapeFullscreen({
      //   fullscreen: {
      //     enterOnRotate: true,
      //     alwaysInLandscapeMode: true,
      //     iOS: false,
      //   },
      // });
      player.hlsQualitySelector({ displayCurrentQuality: true, iOS: true });
      let qualityLevels = player.qualityLevels();
      qualityLevels.on("addqualitylevel", function (event) {
        let qualityLevel = event.qualityLevel;
        if (qualityLevel.height) {
          qualityLevel.enabled = true;
        } else {
          qualityLevels.removeQualityLevel(qualityLevel);
          qualityLevel.enabled = false;
        }
      });
      // p.controlBar.options_.fullscreenToggle = true;
      /*p.controlBar({
              muteToggle: false,
              fullscreenToggle: true
            })*/
      var myButton = p.controlBar.addChild("button", {});
      myButton.addClass("vjs-close-button");
      var myButtonDom = myButton.el();
      myButtonDom.innerHTML =
        '<img src="' + SVGIcon["search-close.svg"] + '" alt="Sign up" />';
      myButton.on(["tap", "click"], myfun);
      function myfun() {
        var CurrentTime = player.currentTime();
        playtracking(
          "Promo",
          CurrentTime,
          data.content_id,
          data.Contentdata.title
        );
        data.functionclose();
      }

      var backwordbtn = p.controlBar.addChild("button", {});
      backwordbtn.addClass("prevbtn");
      var backwordbtnDom1 = backwordbtn.el();
      backwordbtnDom1.innerHTML =
        '<span  class="player__button prevbtn"><img src="' +
        SVGIcon["Reload-Backward.svg"] +
        '" class="backward_player"><span class="hovereffetc"></span</span>';
      backwordbtn.on(["tap", "click"], backforward);

      function backforward() {
        //Call playstatus
        var value = eval(player.currentTime() - 10);
        if (Math.sign(value) != -1) player.currentTime(value);
        var CurrentTime = player.currentTime();
        playstatus(CurrentTime, data.content_id, Xr);
        if (isMobile) {
          backwordbtn.addClass("nextbtnColor");

          var timer2 = setTimeout(() => {
            backwordbtn.removeClass("nextbtnColor");
          }, 500);
          return () => {
            clearTimeout(timer2);
          };
        }
      }

      var forwordbtn = p.controlBar.addChild("button", {});
      forwordbtn.addClass("nextbtn");
      var forwordbtnDom1 = forwordbtn.el();
      forwordbtnDom1.innerHTML =
        '<span  class="player__button nextbtn"><img src="' +
        SVGIcon["Reload-Forward.svg"] +
        '" class="forward_player"><span class="hovereffetc"></span</span>';
      forwordbtn.on(["tap", "click"], seekforward);

      function seekforward() {
        //Call playstatus
        var value = eval(player.currentTime() + 10);
        if (Math.sign(value) != -1) player.currentTime(value);
        var CurrentTime = player.currentTime();
        playstatus(CurrentTime, data.content_id, Xr);
        if (isMobile) {
          forwordbtn.addClass("nextbtnColor");

          var timer2 = setTimeout(() => {
            forwordbtn.removeClass("nextbtnColor");
          }, 500);
          return () => {
            clearTimeout(timer2);
          };
        }
      }
    }

    p.on("timeupdate", function () {
      setloader(false);
      if (data.subscribed === false) {
        var duraction = p.currentTime();
        if (data.content_details.premium_tag) {
          if (duraction > 120) {
            if (p.isFullscreen()) {
              p.exitFullscreen();
              setshowmodel(true);
            } else {
              setshowmodel(true);
            }
            p.pause();
            if (player) player.dispose();
          }
        }
      }
    });

    function myfun() {
      data.functionclose();
    }
    if (typeof player !== "undefined") {
      if (isMobile) {
        //
        window.scrollBy(0, 80);
        document.body.scroll = "no";
      }
    }
    p.on("play", () => {
      if (typeof player !== "undefined") {
        setloader(false);
      }
    });

    p.on("pause", () => {
      playstatus(
        data.content_details.content_type,
        p.currentTime(),
        data.content_id,
        Xr
      );
    });

    p.on("fullscreenchange", () => {
      if (typeof player !== "undefined") {
      }
    });
    setPlayer(p);
    return () => {
      if (player) player.dispose();
    };
  };

  function closebtn() {
    window.history.go(-1);
  }

  const resolutionMap = {
    "2160p": "4K UHD",
    "1440p": "2K",
    "1080p": "FHD",
    "720p": "HD",
    "480p": "SD",
  };

  const qualitLevelLabel = document.querySelectorAll(".vjs-menu-item-text");
  qualitLevelLabel?.forEach((item) => {
    const resolutionText = item.innerText;
    if (resolutionMap.hasOwnProperty(resolutionText)) {
      item.textContent = resolutionMap[resolutionText];
    }
  });

  return (
    <div className="playtrailer">
      <video
        ref={videoRef}
        className="vidPlayer video-js vjs-default-skin vjs-big-play-centered"
        style={{ height: "100vh", width: "100%", background: "#000" }}
        autoPlay
        muted
        controls
        playsInline={true}
      ></video>
    </div>
  );
}
/*--------------Watch Trailer------*/
export function Watchtrailerdetails(data) {
  // Appsflyer("Promo Watched", {
  //   "Promo Name": data.Contentdata.title,
  //   "Content ID": data.Contentdata.ID,
  // });
  // branchIO("Promo Watched", {
  //   "Promo Name": data.Contentdata.title,
  //   "Content ID": data.Contentdata.ID,
  // });
  const videoRef = useRef();
  const [player, setPlayer] = useState(undefined);

  useEffect(() => {
    const videoJsOptions = {
      html5: {
        hls: {
          overrideNative: false,
          nativeControlsForTouch: true,
        },
      },
      hls: {
        withCredentials: true,
      },
      controlBar: {
        muteToggle: false,
        fullscreenToggle: false,
      },
      fullscreen: {
        enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
        alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
        iOS: false, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
      },
      autoplay: true,
      kind: "captions",
      preload: "auto",
      aspectRatio: "15:12",
      height: "100%",
      controlBar: {
        muteToggle: false,
        fullscreenToggle: false,
      },
      width: "100%",
      controls: true,
      playbackRates: [0.5, 0.75, 1, 1.5, 2, 3],
      poster: data.Contentdata.banner_image.medium,
      fullscreen: [
        {
          enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
          alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
          iOS: true, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
        },
      ],
      sources: [
        {
          src: data.Contentdata.promo_url,
          // type: "application/x-mpegURL",
          withCredentials: false,
        },
      ],
    };

    const p = videojs(videoRef.current, videoJsOptions);
    var Xr;
    if (typeof player !== "undefined") {
      Xr = Math.floor(Math.random() * 10000 + 1);
    }
    if (typeof player !== "undefined") {
      p.landscapeFullscreen({
        fullscreen: {
          enterOnRotate: true,
          alwaysInLandscapeMode: true,
          iOS: false,
        },
      });
      player.hlsQualitySelector({ displayCurrentQuality: true });
      let qualityLevels = player.qualityLevels();
      qualityLevels.on("addqualitylevel", function (event) {
        let qualityLevel = event.qualityLevel;
        if (qualityLevel.height) {
          qualityLevel.enabled = true;
        } else {
          qualityLevels.removeQualityLevel(qualityLevel);
          qualityLevel.enabled = false;
        }
      });
      var myButton = p.controlBar.addChild("button", {});
      myButton.addClass("vjs-close-button");
      var myButtonDom = myButton.el();
      myButtonDom.innerHTML =
        '<img src="' + SVGIcon["search-close.svg"] + '" alt="Sign up" />';
      myButton.on(["tap", "click"], myfun);
      function myfun() {
        var CurrentTime = player.currentTime();
        playtracking(
          "Promo",
          CurrentTime,
          data.Contentdata.ID,
          data.Contentdata.title
        );
        data.functionclose();
      }

      var backwordbtn = p.controlBar.addChild("button", {});
      backwordbtn.addClass("prevbtn");
      var backwordbtnDom1 = backwordbtn.el();
      backwordbtnDom1.innerHTML =
        '<span  class="player__button prevbtn"><img src="' +
        SVGIcon["Reload-Backward.svg"] +
        '" class="backward_player"><span class="hovereffetc"></span</span>';
      backwordbtn.on(["tap", "click"], backforward);

      function backforward() {
        //Call playstatus
        var value = eval(player.currentTime() - 10);
        if (Math.sign(value) != -1) player.currentTime(value);
        var CurrentTime = player.currentTime();
        playstatus(CurrentTime, data.Contentdata.ID, Xr);
      }

      var forwordbtn = p.controlBar.addChild("button", {});
      forwordbtn.addClass("nextbtn");
      var forwordbtnDom1 = forwordbtn.el();
      forwordbtnDom1.innerHTML =
        '<span  class="player__button nextbtn"><img src="' +
        SVGIcon["Reload-Forward.svg"] +
        '" class="forward_player"><span class="hovereffetc"></span</span>';
      forwordbtn.on(["tap", "click"], seekforward);

      function seekforward() {
        //Call playstatus
        var value = eval(player.currentTime() + 10);
        if (Math.sign(value) != -1) player.currentTime(value);
        var CurrentTime = player.currentTime();
        playstatus(CurrentTime, data.Contentdata.ID, Xr);
      }
    }

    p.on("play", () => {
      //Call playstatus/

      if (typeof player !== "undefined") {
        var CurrentTime = player.currentTime();
        p.muted(false);
        playstatus(CurrentTime, data.Contentdata.ID, Xr);
        if (typeof player !== "undefined") {
          if (p.requestFullscreen) {
            p.requestFullscreen();
          } else if (p.mozRequestFullScreen) {
            p.mozRequestFullScreen();
          } else if (p.webkitRequestFullScreen) {
            p.webkitRequestFullScreen();
          } else if (p.msRequestFullscreen) {
            p.msRequestFullscreen();
          } else {
            p.webkitEnterFullScreen();
          }
        }
      }
    });

    p.on("pause", () => {
      //Call playstatus
      if (typeof player !== "undefined") {
        p.requestFullscreen();
      }
    });

    p.on("fullscreenchange", () => {
      if (typeof player !== "undefined") {
        if (p.isFullscreen() == false) {
          //Call playstatus
          var CurrentTime = player.currentTime();
          playstatus(CurrentTime, data.Contentdata.ID, Xr);
          playtracking(
            "Promo",
            CurrentTime,
            data,
            data.Contentdata.ID,
            data.Contentdata.title
          );
          data.functionclose();
        }
      }
    });
    setPlayer(p);
    if (p) {
      p.play();
    }
    return () => {
      if (player) {
        player.currentTime = 0;
        player.src = "";
      }
    };
  }, [player]);

  // const qualitLevelLabel1 = document.querySelectorAll('.vjs-menu-item-text');

  // qualitLevelLabel1?.forEach(item => {
  //   if (item.innerText === "2160p") {
  //     item.textContent = "4K UHD";
  //   }
  //   if (item.innerText === "1440p") {
  //     item.textContent = "2K";
  //   }
  //   if (item.innerText === "1080p") {
  //     item.textContent = "FHD";
  //   }
  //   if (item.innerText === "720p") {
  //     item.textContent = "HD";
  //   }
  //   if (item.innerText === "480p") {
  //     item.textContent = "SD";
  //   }
  // })

  return (
    <div className="playtrailer">
      <video
        ref={videoRef}
        className="vidPlayer video-js vjs-default-skin vjs-big-play-centered"
        style={{ height: "100%", width: "100%", background: "#000" }}
        autoplay
        muted
      ></video>
    </div>
  );
}
//Play status Common function (play,pause,close,forward,backward)

function playstatus(type = "", duration, content_id, Xr) {
  Playstatus(type, duration, content_id, Xr).then((resp) => {
    return true;
  });
}

//Play Tracking Common function
function playtracking(type, duration, content_id, title) {
  Playtracking(type, duration, content_id, title).then((resp) => {
    return true;
  });
}
